import { render, staticRenderFns } from "./ImageHead.vue?vue&type=template&id=1b97ff95&scoped=true&"
import script from "./ImageHead.vue?vue&type=script&lang=js&"
export * from "./ImageHead.vue?vue&type=script&lang=js&"
import style0 from "./ImageHead.vue?vue&type=style&index=0&id=1b97ff95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b97ff95",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ImageHead.vue
// module id = null
// module chunks = 